import gql from "graphql-tag";

export default gql`
  query getUploadUrls($folder: String!, $fileExtensions: [String!]!) {
    getUploadUrls(folder: $folder, fileExtensions: $fileExtensions)
  }
`;
